import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _setTimeout from '@babel/runtime-corejs3/core-js-stable/set-timeout';
import { useState, useCallback, useEffect } from 'react';

var COPY_STATUS;
(function (COPY_STATUS) {
  COPY_STATUS[COPY_STATUS["Clean"] = 0] = "Clean";
  COPY_STATUS[COPY_STATUS["Pending"] = 1] = "Pending";
})(COPY_STATUS || (COPY_STATUS = {}));
function useCopy(_ref) {
  var text = _ref.text,
    _ref$block = _ref.block,
    block = _ref$block === void 0 ? {
      duration: 3000
    } : _ref$block;
  var _useState = useState(text.before),
    _useState2 = _slicedToArray(_useState, 2),
    copyText = _useState2[0],
    setCopyText = _useState2[1];
  var _useState3 = useState(COPY_STATUS.Clean),
    _useState4 = _slicedToArray(_useState3, 2),
    status = _useState4[0],
    setStatus = _useState4[1];
  var copy = useCallback(function (value) {
    var textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.position = 'fixed';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    var after = text.after;
    after && setCopyText(after);
    setStatus(COPY_STATUS.Pending);
  }, [text]);
  useEffect(function () {
    if (status === COPY_STATUS.Pending) {
      _setTimeout(function () {
        setCopyText(text.before);
        setStatus(COPY_STATUS.Clean);
      }, block.duration);
    }
  }, [block.duration, status, text.before]);
  return {
    copy: useCallback(function (value) {
      if (status === COPY_STATUS.Pending) {
        return;
      }
      copy(value);
    }, [copy, status]),
    copyText: copyText,
    isCopied: status === COPY_STATUS.Pending
  };
}

export { useCopy as default };
